import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { setLoader } from 'redux/slices/loader';
import { updateUser } from 'redux/slices/auth';
import {
  error as renderError,
  success as renderSuccess,
} from 'helpers/toaster.js';
import { confirmEmail } from 'services/userService';
import metaPixelService from 'services/metaPixelService';

function EmailVerification() {
  const { token } = useParams() || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const confirmEmailFn = async () => {
    try {
      dispatch(
        setLoader({
          isLoading: true,
          heading: 'Verifying your email',
          description: 'Please wait...',
        }),
      );

      const res = await confirmEmail(token);

      dispatch(setLoader({ isLoading: false }));

      if (res?.data?.user) {
        // Get the current user data from localStorage (which includes the token)
        const currentUserData = JSON.parse(localStorage.getItem('user'));

        // Merge the response user data with the existing token
        const userDataWithToken = {
          ...res.data.user,
          token: currentUserData?.token,
          subscriptions: currentUserData?.subscriptions,
          license: currentUserData?.license,
        };

        // Update Redux store with complete user data including token
        dispatch(updateUser({ user: userDataWithToken }));
        renderSuccess(res?.data?.message);

        // Track CompleteRegistration after successful email confirmation and auto-login
        try {
          if (metaPixelService.hasConsent()) {
            await metaPixelService.trackCompleteRegistration(
              res.data.user.email,
              res.data.user.phone || null,
            );
          }
        } catch (error) {
          console.error(
            'Error tracking CompleteRegistration after email confirmation:',
            error,
          );
        }

        // Wait a bit for Redux state to update before navigating
        setTimeout(() => {
          // Check if user came from lifetime deal page
          const lifetimeDealIntent = localStorage.getItem('lifetimeDealIntent');
          if (lifetimeDealIntent) {
            localStorage.removeItem('lifetimeDealIntent');
            navigate('/payment?lifetime=true');
          } else {
            navigate('/');
          }
        }, 100);
      } else {
        renderError('Email confirmation failed');
        // Check if user came from lifetime deal page even on error
        const lifetimeDealIntent = localStorage.getItem('lifetimeDealIntent');
        if (lifetimeDealIntent) {
          localStorage.removeItem('lifetimeDealIntent');
          navigate('/payment?lifetime=true');
        } else {
          navigate('/');
        }
      }
    } catch (error) {
      dispatch(setLoader({ isLoading: false }));
      renderError(error);
      // Check if user came from lifetime deal page even on error
      const lifetimeDealIntent = localStorage.getItem('lifetimeDealIntent');
      if (lifetimeDealIntent) {
        localStorage.removeItem('lifetimeDealIntent');
        navigate('/payment?lifetime=true');
      } else {
        navigate('/');
      }
    }
  };

  useEffect(() => {
    confirmEmailFn();
  }, [token]);

  return <></>;
}

export default EmailVerification;
